"use strict";
"use client";
import { jsx } from "react/jsx-runtime";
import { forwardRef, useState, useCallback } from "react";
import { clsx } from "../../styles/clsx.js";
import { deprecate } from "../../util/logger.js";
import { Dialog } from "../Dialog/Dialog.js";
import { sharedClasses } from "../../styles/shared.js";
import classes from "./Modal.module.css.js";
import { useMedia } from "../../hooks/useMedia/useMedia.js";
const ANIMATION_DURATION = 300;
const Modal = forwardRef((props, ref) => {
  const {
    hideCloseButton,
    variant = "contextual",
    className,
    contentClassName,
    preventClose = false,
    children,
    onClose,
    ...rest
  } = props;
  if (process.env.NODE_ENV !== "production") {
    if (hideCloseButton) {
      deprecate(
        "Modal",
        "The `hideCloseButton` prop has been deprecated. Use the `preventClose` prop instead."
      );
    }
  }
  const [isClosing, setIsClosing] = useState(false);
  const handleModalCloseEnd = useCallback(() => {
    setIsClosing(false);
    onClose == null ? void 0 : onClose();
  }, [onClose]);
  const handleModalCloseStart = useCallback(() => {
    setIsClosing(true);
  }, []);
  const isMobile = useMedia("(max-width: 479px)");
  const outAnimation = isMobile ? sharedClasses.animationSlideUpOut : sharedClasses.animationFadeOut;
  const inAnimation = isMobile ? sharedClasses.animationSlideUpIn : sharedClasses.animationFadeIn;
  return /* @__PURE__ */ jsx(
    Dialog,
    {
      ref,
      isModal: true,
      onCloseStart: handleModalCloseStart,
      onCloseEnd: handleModalCloseEnd,
      animationDuration: ANIMATION_DURATION,
      className: clsx(
        classes.base,
        isClosing ? outAnimation : inAnimation,
        variant === "immersive" && classes.immersive,
        className
      ),
      preventEscapeKeyClose: preventClose,
      preventOutsideClickClose: preventClose,
      hideCloseButton: preventClose,
      ...rest,
      children: /* @__PURE__ */ jsx("div", { className: clsx(classes.content, contentClassName), children: typeof children === "function" ? children == null ? void 0 : children({ onClose }) : children })
    }
  );
});
Modal.displayName = "Modal";
export {
  ANIMATION_DURATION,
  Modal
};
